import { replaceMark, removeMark } from "../../commands/commands";
import { Extension } from "../../core/extension";
import { colors } from "./colors";
import { highlightMarkSpec } from "./schema";
export class HighlightExtension extends Extension {
    addMarks(marks) {
        return marks.append(highlightMarkSpec());
    }
    addCommands(schema) {
        return {
            applyHighlightColor: (color) => {
                if (color === colors[0].value) {
                    return removeMark(schema.marks.highlight, { color });
                }
                return replaceMark(schema.marks.highlight, { color });
            },
        };
    }
}
